import { RoleInterface } from "../RoleInterface";
import { Role } from "../Role";
import Translator from "../../../../../Translation/Translator";

class None extends Role implements RoleInterface  {

  public static contactRoleId: number = 3;

  public getName(): string {
    return Translator.trans("role-none");
  }

}

export { None }
